import React from 'react';

const DataMigrationTool = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Inovaantage Data Migration Tool(RUNr)</h1>
      <p>This is the Inovaantage Data Migration Tool service page.</p>
    </div>
  );
};

export default DataMigrationTool;
